import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
import { getFormTypeRoute } from 'FormsUI/lib/RouteGenerators';
import Log from 'forms-utils-lib/logger/Logger';
import GuidanceModal from 'growth-onboarding-empty-states/GuidanceModal/GuidanceModal';
import DoItMyselfButton from 'growth-onboarding-empty-states/GuidanceModal/buttons/DoItMyselfButton';
import HelpMeGetStartedButton from 'growth-onboarding-empty-states/GuidanceModal/buttons/HelpMeGetStartedButton';
import { EmptyStateTour } from 'FormsUI/components/dashboard/zeroState/freeStarter/EmptyStateTour';
import { navigateTo } from 'FormsUI/utils/UrlUtils';
import { ZERO_STATE_SESSION_STORAGE_FLAG } from 'FormsUI/components/dashboard/zeroState/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const withTracking = fn => (isPortalZeroState, ...args) => {
  if (!isAcceptanceTest()) {
    trackDashboardInteraction('create-new-form', {
      state: isPortalZeroState ? 'zero-state' : 'has-forms'
    });
  }
  fn(...args);
};
const pushRedirectTour = (push, route) => navigateTo(`${route}?onboardingTourId=create-embedded-form-quickly`);
const pushRedirectWithTrackingAndTour = withTracking(pushRedirectTour);
const pushRedirect = (push, route) => push(route);
const pushRedirectWithTracking = withTracking(pushRedirect);
const setTemplateSessionStorage = () => {
  try {
    sessionStorage.setItem(ZERO_STATE_SESSION_STORAGE_FLAG, 'true');
  } catch (_unused) {
    Log.warn('Could not set Zero State session storage value');
  }
};
const EmptyStateButton = ({
  formsWriteAccess = false,
  isRequestStatePending = false,
  isPortalZeroState = false,
  push,
  size = 'small'
}) => {
  const [showTour, setShowTour] = useState(true);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const handleClick = () => {
    setShowWelcomeModal(true);
    setShowTour(false);
  };
  useEffect(() => {
    if (showWelcomeModal) {
      trackDashboardInteraction('viewed-empty-state-welcome-modal');
    }
  }, [showWelcomeModal]);
  const handleWelcomeModalClose = () => {
    trackDashboardInteraction('click-welcome-modal-close-button');
    trackDashboardInteraction('create-new-form', {
      state: isPortalZeroState ? 'zero-state' : 'has-forms'
    });
    setShowWelcomeModal(false);
  };
  const handleWelcomeModalCTAClick = () => {
    setTemplateSessionStorage();
    trackDashboardInteraction('click-help-me-get-started');
    pushRedirectWithTrackingAndTour(isPortalZeroState, push, getFormTypeRoute());
  };
  const handleWelcomeModalManualSetupClick = () => {
    trackDashboardInteraction('click-i-will-setup-myself');
    pushRedirectWithTracking(isPortalZeroState, push, getFormTypeRoute());
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmptyStateTour, {
      hasClosedTourFromModal: !showTour,
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        size: size,
        onClick: handleClick,
        disabled: isRequestStatePending || !formsWriteAccess,
        "data-test-id": "form-creation-button",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "formCreation.formCreationCtaZeroState"
        })
      })
    }), showWelcomeModal && /*#__PURE__*/_jsxs(GuidanceModal, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.zeroState.createYourFirstForm"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.zeroState.weCanHelpSetup"
      }),
      onClose: handleWelcomeModalClose,
      children: [/*#__PURE__*/_jsx(HelpMeGetStartedButton, {
        onClick: event => {
          event.preventDefault();
          handleWelcomeModalCTAClick();
        }
      }), /*#__PURE__*/_jsx(DoItMyselfButton, {
        onClick: event => {
          event.preventDefault();
          handleWelcomeModalManualSetupClick();
        }
      })]
    })]
  });
};
export default EmptyStateButton;